__turbopack_context__.v({
  "pdp-badge": "gS2LcG_pdp-badge",
  "pdp-badge-low-stock": "gS2LcG_pdp-badge-low-stock",
  "pdp-slider-main": "gS2LcG_pdp-slider-main",
  "pdp-wrapper": "gS2LcG_pdp-wrapper",
  "scroll-image-container": "gS2LcG_scroll-image-container",
});
